import type {FC, ReactNode} from "react";
import EmptyState from "./Empty";
import ErrorState from "./Error";
import LoadingScreen from "./Loading";

export type ScreenStateProps = {
  loading?: boolean;
  error?: unknown;
  empty?: boolean;
  emptyTitle?: string;
  emptySubtitle?: string;
  errorMessage?: string;
  children?: ReactNode;
  onRetry?: () => void;
  loadingComponent?: ReactNode;
};

const ScreenState: FC<ScreenStateProps> = props => {
  const {
    loading,
    error,
    empty,
    emptyTitle = "No items found",
    emptySubtitle = "Try adjusting your filters",
    errorMessage,
    children,
    onRetry,
    loadingComponent,
  } = props;

  if (loading) return <LoadingScreen loadingComponent={loadingComponent} />;
  if (error)
    return (
      <ErrorState
        error={error}
        fallbackMessage={errorMessage}
        onRetry={onRetry}
      />
    );
  if (empty) return <EmptyState title={emptyTitle} subtitle={emptySubtitle} />;

  return children;
};

export default ScreenState;
